export default {
  easypaisa__enter_number: 'Enter your Easypaisa number',
  easypaisa__enter_number_jazzcash: 'Enter your JazzCash number',
  easypaisa__placeholder: 'e.g. 03XXXXXXXXX',
  easypaisa__hint: '11 digits, starts with 03',
  easypaisa__validation_error: 'Enter a Valid Easypaisa Wallet No.\n(11 digits, starts with 03)',
  easypaisa__session_timed_out: 'Session timed out',
  easypaisa__close: 'CLOSE',
  easypaisa__confirm: 'CONFIRM',
  easypaisa__try_again: 'TRY AGAIN',
};
